<modal  [title]="title" [tagEventImp]="tagEventImp" [tagEventCTA]="tagEventCTA" [tagEventClose]="tagEventClose">
    @if (hasSwappyError) {
        <p class="text is-marginless">
            Rassurez-vous, vous pouvez vous rendre en boutique pour commander votre téléphone avec Smart Change auprès d’une
            conseillère ou d’un conseiller Bouygues Telecom.
        </p>
    } @else {
        <p class="text is-marginless">
            Bonne nouvelle ! Vous pouvez encore reprendre votre commande pour finaliser le paiement avec Smart Change.
        </p>
    }

    <ng-template #customModalFooter>
        <div class="buttons">
            <button class="button is-primary" (click)="swappyAction()">
                {{ hasSwappyError ? 'Trouver ma boutique' : 'Reprendre la commande' }}
            </button>
            <button class="button is-secondary" (click)="close()">Revenir à l'accueil</button>
        </div>
    </ng-template>
</modal>
